<form [formGroup]="discountMultipleValuationForm">
    <mat-card class="detail-card">
        @let gpNav = gpNav$ | async;
        @let isEditDisabled = isEditDisabled$ | async;
        @if (!navExists(gpNav)) {
            <valumize-info-panel
                [appearance]="'WARNING'" [message]="'GP NAV is missing. Please add a valid amount for NAV first.'"></valumize-info-panel>
        }
        @if (selectedAssetValuation$ | async; as selectedAssetValuation) {
            @if (selectedAssetValuation.data.id) {
                @if (discountMultipleValuation$ | async; as discountMultipleValuation) {
                    <mat-card-subtitle class="detail-card-subtitle-with-actions">
                        @if (dmvError$ | async; as dmvError) {
                            <valumize-info-panel [appearance]="'ERROR'" [message]="dmvError"></valumize-info-panel>
                        }
                        @if (selectedAssetValuation.status === 'SAVED') {
                            <valumize-info-panel [appearance]="'SAVED'"
                                                 [message]="'Discount Multiple Valuation successfully saved'"></valumize-info-panel>
                        }
                        @if (selectedAssetValuation.status === 'LOADING') {
                            <mat-progress-spinner></mat-progress-spinner>
                        }
                    </mat-card-subtitle>

                    <mat-card-content class="detail-card-content-no-title">
                        <div class="key-value-pair-section">
                            <div class="key-value-pair-column">
                                <div>
                                    <div class="key-value-pair">
                                        <div class="key-value-item required-asterisk">Required gIRR</div>
                                        <div class="key-value-item">
                                            @let requiredGrossIRRSource = discountMultipleValuation.persistedAssetValuation.requiredGrossIRR.source;
                                            @if (isEditable) {
                                                <span class="value-with-gear">
                                                    <valumize-source-gear [source]="requiredGrossIRRSource"></valumize-source-gear>
                                                    <div>{{ discountMultipleValuation.persistedAssetValuation.requiredGrossIRR | traceableFormat }}</div>
                                                </span>
                                                <div>
                                                    <input matInput
                                                           type="number"
                                                           formControlName="calculatedRequiredGrossIRR"
                                                           id="calculatedRequiredGrossIRR"
                                                           class="input-number-narrow"
                                                           (change)="calcAndSave('calculatedRequiredGrossIRR')">
                                                </div>
                                            } @else {
                                                <span class="value-with-gear">
                                                    <valumize-source-gear [source]="requiredGrossIRRSource"></valumize-source-gear>
                                                    {{ discountMultipleValuation.persistedAssetValuation.requiredGrossIRR | traceableFormat }}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    @if (isEditable) {
                                        <div class="key-value-pair">
                                            <div class="key-value-item">Valuation Input</div>
                                            <div class="key-value-item">
                                                <mat-button-toggle-group style="margin: 0.5rem" #group="matButtonToggleGroup" [value]="selectedValuationInput"
                                                                         (change)="onValuationInputChange(group.value)" id="valuationInputToggle">
                                                    <mat-button-toggle value="MULTIPLE">Multiple</mat-button-toggle>
                                                    <mat-button-toggle value="CF">CF</mat-button-toggle>
                                                </mat-button-toggle-group>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="key-value-pair-column">
                                <div>
                                    <div class="key-value-pair">
                                        <div class="key-value-item">Bid Price</div>
                                        <div class="key-value-item">
                                            <div>{{ discountMultipleValuation.persistedAssetValuation.finalBidPrice | traceableFormat }}</div>
                                            <div>
                                                @if (isEditable) {
                                                    {{ discountMultipleValuation.calcAssetValuation.finalBidPrice | traceableFormat }}
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="key-value-pair">
                                        <div class="key-value-item">Discount to GP NAV</div>
                                        <div class="key-value-item">
                                            <div>{{ discountMultipleValuation.persistedAssetValuation.discountToGpNAV | traceableFormat }}</div>
                                            <div>
                                                @if (isEditable) {
                                                    {{ discountMultipleValuation.calcAssetValuation.discountToGpNAV | traceableFormat }}
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dmv-table">
                            <table mat-table [dataSource]="discountMultipleValuation.tableDataSource" class="dmv-table">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>
                                        @if (isEditable) {
                                            Exit Date * :
                                            <mat-form-field class="date-form-field input-date-narrow">
                                                <input matInput
                                                       formControlName="mostRecentCashflowDate"
                                                       id="mostRecentCashflowDate"
                                                       (dateChange)="calcAndSave('mostRecentCashflowDate')"
                                                       [matDatepicker]="cashflowDatePicker">
                                                <mat-hint>dd/MM/yyyy</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix [for]="cashflowDatePicker"></mat-datepicker-toggle>
                                                <mat-datepicker #cashflowDatePicker></mat-datepicker>
                                            </mat-form-field>
                                            <br>
                                        } @else {
                                            Exit Date * : {{ discountMultipleValuation.mostRecentCashflowDate | date }}
                                        }
                                        @if (fundCurrency) {
                                            <valumize-currency-badge
                                                kind="FUND"
                                                [iso]="fundCurrency"
                                                size="compact"
                                                tooltip="DMV amounts are in the fund's reporting currency">
                                            </valumize-currency-badge>
                                        }
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (element.definition !== 'cashflows') {
                                            {{ element.name }}
                                        } @else {
                                            <div>
                                                <div>{{ translateCashflowType(element.name) | async }}</div>
                                            </div>
                                        }
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="low">
                                    <th mat-header-cell *matHeaderCellDef>Low</th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (element.definition !== 'cashflows') {
                                            {{ element.low | traceableFormat }}
                                        } @else {
                                            <div>
                                                <div>{{ element.low.amount | traceableFormat }}</div>
                                                <div>{{ element.low.navMultiple | traceableFormat }}</div>
                                            </div>
                                        }
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="lowCalc">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (isEditable) {
                                            @if (formControlIsEditable(element)) {
                                                @if (isCashflowValuation()) {
                                                    <input matInput
                                                           type="number"
                                                           [id]="getFormControl('lowCalc', element)"
                                                           [value]="element.lowCalc?.amount | traceableFormat"
                                                           class="input-number-narrow"
                                                           [class.cell-empty]="isCellEmpty('lowCalc', element, 'currency')"
                                                           [disabled]="isDisabledscenarioInput"
                                                           (input)="onFormValueInput($event,element,'currency','lowCalc')"
                                                           (change)="onFormValueChange($event,element,'currency','lowCalc')">
                                                    <div>
                                                        {{ element?.lowCalc?.navMultiple | traceableFormat }}
                                                    </div>
                                                } @else {
                                                    <div>
                                                        {{ element?.lowCalc?.amount | traceableFormat }}
                                                    </div>
                                                    <input matInput
                                                           type="number"
                                                           [id]="getFormControl('lowCalc', element)"
                                                           [value]="element.lowCalc?.navMultiple?.factor"
                                                           class="input-number-narrow"
                                                           [class.cell-empty]="isCellEmpty('lowCalc', element, 'multiple')"
                                                           [disabled]="isDisabledscenarioInput"
                                                           (input)="onFormValueInput($event,element,'multiple','lowCalc')"
                                                           (change)="onFormValueChange($event,element,'multiple','lowCalc')">
                                                }
                                            } @else {
                                                {{ element.lowCalc | traceableFormat }}
                                            }
                                        }
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="base">
                                    <th mat-header-cell *matHeaderCellDef>Base</th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (element.definition !== 'cashflows') {
                                            {{ element.base | traceableFormat }}
                                        } @else {
                                            <div>
                                                <div>{{ element.base.amount | traceableFormat }}</div>
                                                <div>{{ element.base.navMultiple | traceableFormat }}</div>
                                            </div>
                                        }
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="baseCalc">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (isEditable) {
                                            @if (formControlIsEditable(element)) {
                                                @if (isCashflowValuation()) {
                                                    <input matInput
                                                           type="number"
                                                           [id]="getFormControl('baseCalc', element)"
                                                           [value]="element.baseCalc?.amount | traceableFormat"
                                                           class="input-number-narrow"
                                                           [class.cell-empty]="isCellEmpty('baseCalc', element, 'currency')"
                                                           [disabled]="isDisabledscenarioInput"
                                                           (input)="onFormValueInput($event,element,'currency','baseCalc')"
                                                           (change)="onFormValueChange($event,element,'currency','baseCalc')">
                                                    <div>
                                                        {{ element?.baseCalc?.navMultiple | traceableFormat }}
                                                    </div>
                                                } @else {
                                                    <div>
                                                        {{ element?.baseCalc?.amount | traceableFormat }}
                                                    </div>
                                                    <input matInput
                                                           type="number"
                                                           [id]="getFormControl('baseCalc', element)"
                                                           [value]="element.baseCalc?.navMultiple?.factor"
                                                           class="input-number-narrow"
                                                           [class.cell-empty]="isCellEmpty('baseCalc', element, 'multiple')"
                                                           [disabled]="isDisabledscenarioInput"
                                                           (input)="onFormValueInput($event,element,'multiple','baseCalc')"
                                                           (change)="onFormValueChange($event,element,'multiple','baseCalc')">
                                                }
                                            } @else {
                                                {{ element.baseCalc | traceableFormat }}
                                            }
                                        }
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="high">
                                    <th mat-header-cell *matHeaderCellDef>High</th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (element.definition !== 'cashflows') {
                                            {{ element.high | traceableFormat }}
                                        } @else {
                                            <div>
                                                <div>{{ element.high.amount | traceableFormat }}</div>
                                                <div>{{ element.high.navMultiple | traceableFormat }}</div>
                                            </div>
                                        }
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="highCalc">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        @if (isEditable) {
                                            @if (formControlIsEditable(element)) {
                                                @if (isCashflowValuation()) {
                                                    <input matInput
                                                           type="number"
                                                           [id]="getFormControl('highCalc', element)"
                                                           [value]="element.highCalc?.amount | traceableFormat"
                                                           class="input-number-narrow"
                                                           [class.cell-empty]="isCellEmpty('highCalc', element, 'currency')"
                                                           [disabled]="isDisabledscenarioInput"
                                                           (input)="onFormValueInput($event,element,'currency','highCalc')"
                                                           (change)="onFormValueChange($event,element,'currency','highCalc')">
                                                    <div>
                                                        {{ element?.highCalc?.navMultiple | traceableFormat }}
                                                    </div>
                                                } @else {
                                                    <div>
                                                        {{ element?.highCalc?.amount | traceableFormat }}
                                                    </div>
                                                    <input matInput
                                                           type="number"
                                                           [id]="getFormControl('highCalc', element)"
                                                           [value]="element.highCalc?.navMultiple?.factor"
                                                           class="input-number-narrow"
                                                           [class.cell-empty]="isCellEmpty('highCalc', element, 'multiple')"
                                                           [disabled]="isDisabledscenarioInput"
                                                           (input)="onFormValueInput($event,element,'multiple','highCalc')"
                                                           (change)="onFormValueChange($event,element,'multiple','highCalc')">
                                                }
                                            } @else {
                                                {{ element.highCalc | traceableFormat }}
                                            }
                                        }
                                    </td>
                                </ng-container>

                                @if (isEditable) {
                                    <ng-container matColumnDef="delete">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element">
                                            @if (deletableRow(element)) {
                                                <button
                                                    color="primary"
                                                    (click)="deleteCashflows(element)"
                                                    mat-icon-button>
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            }
                                        </td>
                                    </ng-container>
                                }

                                <tr mat-header-row *matHeaderRowDef="discountMultipleValuation.tableColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: discountMultipleValuation.tableColumns;"
                                    class="{{styleRowImportant(row)}} {{styleRowBorderTop(row)}} {{styleRowBorderBottom(row)}}">
                                </tr>
                            </table>
                        </div>
                        <div style="display: flex; align-items: baseline;">
                            <button (click)="openNewCashflowDialog()"
                                    [disabled]="isEditDisabled! || noExitCashflow()"
                                    class="add-cashflow-button"
                                    color="primary"
                                    mat-raised-button>
                                Add New Cashflow
                            </button>
                            @if (notAssignedCapex$ | async; as capex) {
                                @if (capex.LOW !== 0 || capex.BASE !== 0 || capex.HIGH !== 0) {
                                    <mat-icon color="warn"
                                              [matTooltip]="'Unassigned Capex Drawdown:' +
                                              '\nLow: ' + (capex.LOW | decimalFormat:'currency') +
                                              '\nBase: ' + (capex.BASE | decimalFormat:'currency') +
                                              '\nHigh: ' + (capex.HIGH | decimalFormat:'currency')"
                                              matTooltipClass="custom-tooltip">
                                        info_outline
                                    </mat-icon>
                                }
                            }
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="detail-card-actions">
                        @let confidenceZone = confidenceZone$ | async;
                        @if (confidenceZone && confidenceZone !== "WITHIN_RANGE") {
                            <span class="confidence-chip"
                                  [class.confidence-chip-outside]="confidenceZone === 'OUTSIDE_RANGE'"
                                  [matTooltip]="confidenceZoneTooltip(confidenceZone)"
                                  data-test="dmv-confidence-chip">
                                <mat-icon>warning_amber</mat-icon>
                                {{ confidenceZoneLabel(confidenceZone) }}
                            </span>
                        }
                        @if (!isEditable) {
                            <div class="last-modified" data-test="modification-date" [hidden]="!navExists(gpNav)">
                                Last modified: {{ discountMultipleValuation.persistedAssetValuation.finalBidPrice.modDate | timestamp }}
                            </div>
                            <button (click)="editMode()"
                                    [disabled]="isEditDisabled!"
                                    [hidden]="!navExists(gpNav)"
                                    color="primary"
                                    data-test="edit-button"
                                    mat-icon-button>
                                <mat-icon>edit</mat-icon>
                            </button>
                        }
                        @if (!isEditable && discountMultipleValuation.persistedAssetValuation.id) {
                            <button (click)="onResetValuation()"
                                    [disabled]="isEditDisabled!"
                                    color="primary"
                                    data-test="reset-button"
                                    mat-icon-button
                                    aria-label="Reset valuation"
                                    matTooltip="Reset valuation">
                                <mat-icon>restart_alt</mat-icon>
                            </button>
                        }
                        @if (requiredFieldsForAlgorithmLookup$ | async; as requiredFields) {
                            <div [matTooltip]="tootTipMessage(requiredFields, discountMultipleValuation.tableDataSource)"
                                 [matTooltipDisabled]="validateValuationLookup(requiredFields, discountMultipleValuation.tableDataSource)">
                                @if (isEditable) {
                                    <button (click)="calcAndSave('', false, true)"
                                            [disabled]="!validateValuationLookup(requiredFields, discountMultipleValuation.tableDataSource)"
                                            class="image-button"
                                            mat-icon-button>
                                        <img alt="dmv with valuation algorithm" src="assets/logo.svg"/>
                                    </button>
                                }
                            </div>
                        }
                        @if (isEditable) {
                            <div [matTooltip]="'All scenarios (Low / Base / High) and their cashflows must be filled before saving.'"
                                 [matTooltipDisabled]="canSave()">
                                <button (click)="calcAndSave('', true)"
                                        [disabled]="!canSave()"
                                        color="primary"
                                        data-test="save-button"
                                        mat-icon-button>
                                    <mat-icon>save</mat-icon>
                                </button>
                            </div>
                            <button (click)="cancel()"
                                    color="primary"
                                    data-test="cancel-button"
                                    mat-icon-button>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        }
                    </mat-card-actions>
                    <valumize-asset-valuation-rationale
                        [assetValuation]="discountMultipleValuation.persistedAssetValuation"
                        [rationaleIsEditable]="discountMultipleValuation.rationaleIsEditable"
                        (saveRationale)="onSaveRationale(discountMultipleValuation.persistedAssetValuation, $event)"
                        (editRationale)="onEditRationale()"
                        (cancelRationale)="onCancelRationale()">
                    </valumize-asset-valuation-rationale>
                }
            } @else {
                <mat-card-content class="detail-card-content" style="color: grey">
                    Please select valuation first!
                </mat-card-content>
            }
        }
    </mat-card>
</form>
